import React from "react";
import "./landingPage.css";

const ActionButton = (props) => {
  const roundedStyles = {
    borderRadius: "30px",
    border: `solid 2px ${props.foregroundColor}`,
    paddingLeft: "50px",
    paddingRight: "50px",
    width: "70%",
    display: "flex",
    justifyContent: "center",
    "@media screen and (max-width: 450px)": {
      width: "92%",
      paddingLeft: "4%",
      paddingRight: "4%"
    }
  };

  const rectStyles = {
    borderRadius: "4px",
    border: "none",
    paddingLeft: "25px",
    paddingRight: "25px"
  };

  let commonStyles = {
    ...props.style,
    minHeight: "48px",
    lineHeight: "48px",
    width: props.width,
    textAlign: "center",
    textTransform: "uppercase",
    backgroundColor: props.backgroundColor,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: props.foregroundColor,
    fontSize: "18px",
    transition: "0.5s ease",
    fontWeight: 700,
    ":hover:not(:disabled)": {
      backgroundColor: props.hoverBackgroundColor || props.foregroundColor,
      color: props.hoverForegroundColor || props.backgroundColor
    }
  };

  switch (props.type) {
    case "rounded":
      commonStyles = { ...roundedStyles, ...commonStyles };
      break;
    case "rect":
      commonStyles = { ...rectStyles, ...commonStyles };
      break;
  }

  return props.link ? (
    <a
    className="applyButton"
    data-cy={props.dataCy}
      disabled={props.disabled}
      onClick={props.onClick}
      href={props.link}
      rel="external noopener"
      target={props.target || "_blank"}
    >
      {props.children}
    </a>
  ) : (
    <button
    className="applyButton"
  
      data-cy={props.dataCy}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
};

export default ActionButton;